import { sva } from "styled-system/css";

export const pressableSquareButtonRecipe = sva({
  slots: ["root", "inner", "bottom"],
  base: {
    root: {
      width: "60px",
      position: "relative",
      cursor: "pointer",
      _disabled: {
        cursor: "not-allowed",
        opacity: 0.6,
      },
      _focusVisible: {
        transform: "translateY(-1px)",
        outline: "2px solid",
        outlineColor: "border.mid",
        outlineOffset: "2px",
        borderRadius: "150"
      },
    },
    inner: {
      width: "60px",
      height: "60px",
      borderRadius: "150",
      p: "100",
      backgroundColor: "white",
      border: "2px solid",
      borderColor: "border.light",
      color: "icon.mid",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      transition: "all 0.2s ease",
      _hover: {
        transform: "translateY(-1px)",
      },

      _active: {
        transform: "translateY(6px)",
      },
      position: "relative",
      zIndex: 2,
    },
    bottom: {
      position: "absolute",
      bottom: "-6px",
      width: "60px",
      height: "40px",
      borderRadius: "150",
      backgroundColor: "bg.lightest",
      border: "2px solid",
      borderColor: "border.light",
      zIndex: 1,
    },
  },
  variants: {
    visual: {
      primary: {},
      "accent.blue": {
        inner: {
          borderColor: "border.accent.blue",
          color: "icon.accent.blue.mid",
        },
        bottom: {
          borderColor: "border.accent.blue",
          bg: "bg.accent.blue.mid",
        },
      },
      "accent.purple": {
        inner: {
          borderColor: "border.accent.purple",
          color: "icon.accent.purple.mid",
        },
        bottom: {
          borderColor: "border.accent.purple",
          bg: "bg.accent.purple.mid",
        },
      },
      "accent.magenta": {
        inner: {
          borderColor: "border.accent.magenta",
          color: "icon.accent.magenta.mid",
        },
        bottom: {
          borderColor: "border.accent.magenta",
          bg: "bg.accent.magenta.mid",
        },
      },
      success: {
        inner: {
          borderColor: "border.success",
          color: "icon.success.mid",
        },
        bottom: {
          borderColor: "border.success",
          bg: "bg.success.mid",
        },
      },
      warning: {
        inner: {
          borderColor: "border.warning",
          color: "icon.warning.mid",
        },
        bottom: {
          borderColor: "border.warning",
          bg: "bg.warning.mid",
        },
      },
      error: {
        inner: {
          borderColor: "border.error",
          color: "icon.error.mid",
        },
        bottom: {
          borderColor: "border.error",
          bg: "bg.error.mid",
        },
      },
      highlight: {
        inner: {
          borderColor: "border.highlight",
          color: "icon.highlight.mid",
        },
        bottom: {
          borderColor: "border.highlight",
          bg: "bg.highlight.mid",
        },
      },
    },
  },
  defaultVariants: {
    visual: "primary",
  },
});
